import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from "redux-persist/integration/react";
import { datadogRum } from '@datadog/browser-rum';
import { consts } from './common/consts';

import App from './App';
import store from './store/appStore';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') ?? "";
const rootElement = document.getElementById('root');

datadogRum.init({
    applicationId: consts.DataDogDevUatApplicationId,
    clientToken: consts.DataDogDevUatClientToken,
    site: 'datadoghq.com',
    service: consts.DataDogServiceName,
    env: consts.DataDogEnvName,
    sampleRate: 100,
    trackInteractions: true
});

ReactDOM.render(
    <Provider store={store.appStore}>
        <PersistGate loading={null} persistor={store.persistor}>
            <BrowserRouter basename={baseUrl} getUserConfirmation={(payload, callback) => {
                const { action, message } = JSON.parse(payload);

                const confirmed = window.confirm(message)

                callback(confirmed)

                if (!confirmed && action === 'POP') window.history.forward()
            }}>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>,
    rootElement);
